import Vue from 'vue'

export default {
	state: {
		cacher_path: 'https://host.coxmediagroup.com/cop/digital/common/cache/cacher.php',
		file_get_path: 'https://host.coxmediagroup.com/cop/digital/common/php/simple_get_file.php'
	},

	create_cacher_url: function(saveas, data_url, force_reload, max_cache_lifetime) {
		let vm = this;
		let cacher_url = vm.state.cacher_path;
		cacher_url += '?saveas='+saveas;

		if(force_reload) {
			cacher_url += '&force_reload=true';
		}

		if(max_cache_lifetime) {
			cacher_url += '&max_cache_lifetime='+max_cache_lifetime;
		}

		cacher_url += '&json_url='+encodeURIComponent(data_url);

		return cacher_url;
	},

	create_file_get_url: function(file_url) {
		let vm = this;
		let file_get_url = vm.state.file_get_path;
		file_get_url += '?url=';
		file_get_url += encodeURIComponent(file_url);

		return file_get_url;
	},

	
}


// WEBPACK FOOTER //
// ./src/store/modules/mod_cacher.js